import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { translate } from 'react-i18next';
import '../../components/default.css';
import { listAllProject, getProject } from '../../redux/projects/projects_actions';
import { listBuildingType } from '../../redux/building_type/building_type_actions';
import { listProvinces } from '../../redux/provinces/province_actions';
import { listEvaluationPurpose } from '../../redux/references/evaluation_purpose_actions';
import { defaultRejectHandler } from '../../utils/utility';
import SummaryCard from '../../components/summarycard/SummaryCard';
import ProjectList from '../../components/projectlist/ProjectList';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import { Button, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import Constants from '../../config/constants';
import axios from 'axios';
import { serializeParams } from '../../utils/rest-service';

const EVALUATION_STATUS_OPTIONS = [
  { id: 'DRF', labelTh: 'ร่าง', labelEn: 'Draft' },
  { id: 'SUB', labelTh: 'เสร็จสิ้น', labelEn: 'Done' },
  { id: 'REJ', labelTh: 'ไม่ผ่านการอนุมัติ', labelEn: 'Rejected' },
  { id: 'APP', labelTh: 'ผ่านการอนุมัติแล้ว', labelEn: 'Approved' },
];

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 10,
      selectedBuildingTypeIds: [],
      selectedProvinceIds: [],
      selectedEvaluationStatuses: [],
      selectedEvaluationPurposeIds: [],
      areaMin: '',
      areaMax: '',
      dateFrom: '',
      dateTo: '',
      // FRS 4.2.3 (4.2) - Dashboard range filters (tCO2eq/ปี)
      carbonMin: '',
      carbonMax: '',
      reductionMin: '',
      reductionMax: '',
      openDropdown: null,
      filterExpanded: true,
      carbonKpi: null,
    };
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.props.listProject(page, pageSize, this.buildFilterParams());
    this.props.listBuildingTypes();
    this.props.listProvinces();
    this.props.listEvaluationPurpose();
    this.fetchCarbonKpi();
    document.addEventListener('mousedown', this.handleDocumentMouseDown);
  }

  // FRS 4.2.3 (4.2) - รวม Operational Carbon / Carbon Reduction ของทุกโครงการ
  fetchCarbonKpi() {
    const accessToken = localStorage.getItem('access-token');
    const headers = {};
    if (accessToken) {
      headers['Authorization'] = `Token ${accessToken}`;
    }
    axios({ method: 'get', url: Constants.API_CARBON_KPI, headers })
      .then(response => this.setState({ carbonKpi: response.data }))
      .catch(err => console.error('Carbon KPI error:', err));
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentMouseDown);
  }

  handleDocumentMouseDown = (e) => {
    if (this.filterRef && !this.filterRef.contains(e.target)) {
      if (this.state.openDropdown) {
        this.setState({ openDropdown: null });
      }
    }
  }

  buildFilterParams() {
    const params = {};

    if (this.state.selectedProvinceIds.length > 0) {
      params.province_id = this.state.selectedProvinceIds;
    }
    if (this.state.selectedBuildingTypeIds.length > 0) {
      params.building_type_id = this.state.selectedBuildingTypeIds;
    }
    if (this.state.selectedEvaluationStatuses.length > 0) {
      params.status = this.state.selectedEvaluationStatuses;
    }
    if (this.state.selectedEvaluationPurposeIds.length > 0) {
      params.evaluation_purpose = this.state.selectedEvaluationPurposeIds;
    }
    if (this.state.areaMin !== '') {
      params.area_min = this.state.areaMin;
    }
    if (this.state.areaMax !== '') {
      params.area_max = this.state.areaMax;
    }
    if (this.state.dateFrom) {
      params.date_from = this.state.dateFrom;
    }
    if (this.state.dateTo) {
      params.date_to = this.state.dateTo;
    }
    if (this.state.carbonMin !== '') {
      params.carbon_min = this.state.carbonMin;
    }
    if (this.state.carbonMax !== '') {
      params.carbon_max = this.state.carbonMax;
    }
    if (this.state.reductionMin !== '') {
      params.reduction_min = this.state.reductionMin;
    }
    if (this.state.reductionMax !== '') {
      params.reduction_max = this.state.reductionMax;
    }

    return params;
  }

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.props.listProject(this.state.page, this.state.pageSize, this.buildFilterParams());
    });
  }

  handleClearFilters = () => {
    this.setState({
      selectedBuildingTypeIds: [],
      selectedProvinceIds: [],
      selectedEvaluationStatuses: [],
      selectedEvaluationPurposeIds: [],
      areaMin: '',
      areaMax: '',
      dateFrom: '',
      dateTo: '',
      carbonMin: '',
      carbonMax: '',
      reductionMin: '',
      reductionMax: '',
      openDropdown: null,
      page: 0,
    }, () => {
      this.props.listProject(this.state.page, this.state.pageSize, this.buildFilterParams());
    });
  }

  handleExportReport = () => {
    const params = this.buildFilterParams();
    const accessToken = localStorage.getItem('access-token');
    const headers = {};
    if (accessToken) {
      headers['Authorization'] = `Token ${accessToken}`;
    }

    axios({
      method: 'get',
      url: Constants.API_PROJECT_EXPORT,
      params,
      paramsSerializer: serializeParams,
      headers,
      responseType: 'blob',
    })
      .then(response => {
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'project_export.xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, '');
          }
        }
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch(err => {
        console.error('Export error:', err);
      });
  }

  renderMultiSelectDropdown({ dropdownKey, options, selectedIds, onToggle, getLabel, allLabelTh, allLabelEn }) {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const isOpen = this.state.openDropdown === dropdownKey;
    const displayText = selectedIds.length === 0
      ? l(allLabelTh || 'ทั้งหมด', allLabelEn || 'All')
      : `${selectedIds.length} ${l('รายการ', 'selected')}`;

    const dropdownStyle = {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      zIndex: 1050,
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      borderRadius: 4,
      maxHeight: 220,
      overflowY: 'auto',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    };

    const itemStyle = {
      padding: '6px 12px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      userSelect: 'none',
    };

    const handleToggleAll = () => {
      onToggle([]);
      this.setState({ openDropdown: null });
    };

    const handleToggleItem = (id) => {
      const idStr = String(id);
      const newIds = selectedIds.includes(idStr)
        ? selectedIds.filter(x => x !== idStr)
        : [...selectedIds, idStr];
      onToggle(newIds);
    };

    return (
      <div style={{ position: 'relative' }}>
        <button
          type="button"
          className="form-control"
          style={{ textAlign: 'left', cursor: 'pointer', background: '#fff' }}
          onClick={() => this.setState({ openDropdown: isOpen ? null : dropdownKey })}
        >
          {displayText}
          <span style={{ float: 'right', color: '#999' }}>&#9662;</span>
        </button>
        {isOpen && (
          <div style={dropdownStyle}>
            <div
              style={{ ...itemStyle, borderBottom: '1px solid #eee', fontWeight: 500 }}
              onClick={handleToggleAll}
            >
              <input
                type="checkbox"
                readOnly
                checked={selectedIds.length === 0}
                style={{ marginRight: 4 }}
              />
              {l('ทั้งหมด', 'All')}
            </div>
            {options.map(opt => {
              const idStr = String(opt.id);
              return (
                <div
                  key={opt.id}
                  style={itemStyle}
                  onClick={() => handleToggleItem(opt.id)}
                >
                  <input
                    type="checkbox"
                    readOnly
                    checked={selectedIds.includes(idStr)}
                    style={{ marginRight: 4 }}
                  />
                  {getLabel(opt)}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  renderFilterBar() {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const buildingTypeLabel = bt => bt[`name_${lang}`] || bt.name || bt.label || '';
    const purposeLabel = ep => ep[`name_${lang}`] || ep.name || ep.label || '';
    const { filterExpanded } = this.state;

    const filterHeader = (
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', userSelect: 'none' }}
        onClick={() => this.setState({ filterExpanded: !filterExpanded })}
      >
        <span>{l('ตัวกรอง (Filter)', 'Filter')}</span>
        <i
          className={`fas fa-chevron-${filterExpanded ? 'up' : 'down'}`}
          style={{ color: '#888', transition: 'transform 0.2s' }}
        />
      </div>
    );

    return (
      <Row className="show-grid">
        <Col xs={12}>
          <Card header={filterHeader} padding={true}>
            <div ref={el => { this.filterRef = el; }}>
              <div style={{
                overflow: 'hidden',
                maxHeight: filterExpanded ? 600 : 0,
                opacity: filterExpanded ? 1 : 0,
                transition: 'max-height 0.3s ease, opacity 0.2s ease',
              }}>
              <Form horizontal>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('ประเภทอาคาร', 'Building type')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'buildingType',
                      options: this.props.buildingTypes || [],
                      selectedIds: this.state.selectedBuildingTypeIds,
                      onToggle: ids => this.setState({ selectedBuildingTypeIds: ids }),
                      getLabel: buildingTypeLabel,
                    })}
                  </Col>
                  <Col componentClass={ControlLabel} sm={2}>{l('จังหวัด', 'Province')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'province',
                      options: this.props.provinces || [],
                      selectedIds: this.state.selectedProvinceIds,
                      onToggle: ids => this.setState({ selectedProvinceIds: ids }),
                      getLabel: pv => pv.name || '',
                    })}
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('สถานะการประเมิน', 'Evaluation status')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'evalStatus',
                      options: EVALUATION_STATUS_OPTIONS,
                      selectedIds: this.state.selectedEvaluationStatuses,
                      onToggle: ids => this.setState({ selectedEvaluationStatuses: ids }),
                      getLabel: opt => l(opt.labelTh, opt.labelEn),
                    })}
                  </Col>
                  <Col componentClass={ControlLabel} sm={2}>{l('เหตุผลของการประเมิน', 'Evaluation purpose')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'evalPurpose',
                      options: this.props.evaluationPurposes || [],
                      selectedIds: this.state.selectedEvaluationPurposeIds,
                      onToggle: ids => this.setState({ selectedEvaluationPurposeIds: ids }),
                      getLabel: purposeLabel,
                    })}
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('พื้นที่อาคาร (ตร.ม.)', 'Building area (m²)')}</Col>
                  <Col sm={4}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <FormControl
                        type="number"
                        placeholder={l('ต่ำสุด', 'Min')}
                        value={this.state.areaMin}
                        onChange={e => this.setState({ areaMin: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                      <span style={{ color: '#666', flexShrink: 0 }}>–</span>
                      <FormControl
                        type="number"
                        placeholder={l('สูงสุด', 'Max')}
                        value={this.state.areaMax}
                        onChange={e => this.setState({ areaMax: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('ช่วง Operational Carbon (tCO2eq/ปี)', 'Operational Carbon range (tCO2eq/year)')}</Col>
                  <Col sm={4}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <FormControl
                        type="number"
                        placeholder={l('ต่ำสุด', 'Min')}
                        value={this.state.carbonMin}
                        onChange={e => this.setState({ carbonMin: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                      <span style={{ color: '#666', flexShrink: 0 }}>–</span>
                      <FormControl
                        type="number"
                        placeholder={l('สูงสุด', 'Max')}
                        value={this.state.carbonMax}
                        onChange={e => this.setState({ carbonMax: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </Col>
                  <Col componentClass={ControlLabel} sm={2}>{l('ช่วง Carbon Reduction (tCO2eq/ปี)', 'Carbon Reduction range (tCO2eq/year)')}</Col>
                  <Col sm={4}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <FormControl
                        type="number"
                        placeholder={l('ต่ำสุด', 'Min')}
                        value={this.state.reductionMin}
                        onChange={e => this.setState({ reductionMin: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                      <span style={{ color: '#666', flexShrink: 0 }}>–</span>
                      <FormControl
                        type="number"
                        placeholder={l('สูงสุด', 'Max')}
                        value={this.state.reductionMax}
                        onChange={e => this.setState({ reductionMax: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('ช่วงวันที่', 'Date range')}</Col>
                  <Col sm={4}>
                    <FormControl
                      type="date"
                      value={this.state.dateFrom}
                      onChange={e => this.setState({ dateFrom: e.target.value })}
                    />
                  </Col>
                  <Col componentClass={ControlLabel} sm={2}>{l('ถึง', 'To')}</Col>
                  <Col sm={4}>
                    <FormControl
                      type="date"
                      value={this.state.dateTo}
                      onChange={e => this.setState({ dateTo: e.target.value })}
                    />
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col smOffset={2} sm={10}>
                    <Button bsStyle="primary" style={{ marginRight: 8 }} onClick={this.handleSearch}>
                      {l('ค้นหา', 'Search')}
                    </Button>
                    <Button style={{ marginRight: 8 }} onClick={this.handleClearFilters}>
                      {l('ล้างค่า', 'Clear')}
                    </Button>
                    <Button bsStyle="success" onClick={this.handleExportReport}>
                      <i className="fas fa-file-export" style={{ marginRight: 6 }} />
                      {l('ออกรายงาน', 'Export Report')}
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    const { projects, t } = this.props;
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const breadcrumbItems = [{ name: t('dashboard'), path: '/dashboard' }];

    const { carbonKpi } = this.state;
    const carbonFmt = v => getFormatter(FORMATTER_STYLE.decimal)(Number(v || 0).toFixed(2));
    const summaryItems = [
      {
        title: t('total projects'),
        number: this.props.totalCount || 0,
        unit: t('projects'),
        iconClass: 'fas fa-folder fa-3x',
      },
      {
        title: l('โครงการประเมินแล้วเสร็จ', 'Completed projects'),
        number: this.props.submittedCount || 0,
        unit: t('projects'),
        iconClass: 'fas fa-check fa-3x',
      },
    ].map(item => ({ ...item, number: getFormatter(FORMATTER_STYLE.decimal)(item.number) }));

    // FRS 4.2.3 (4.2) - Carbon KPI cards
    summaryItems.push(
      {
        title: t('operational carbon total'),
        number: carbonFmt(carbonKpi && carbonKpi.operational_carbon_total_t),
        unit: t('tCO2eq per year'),
        iconClass: 'fas fa-smog fa-3x',
      },
      {
        title: t('carbon reduction total'),
        number: carbonFmt(carbonKpi && carbonKpi.carbon_reduction_total_t),
        unit: t('tCO2eq per year'),
        iconClass: 'fas fa-leaf fa-3x',
      },
    );

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
      >
        <Grid>
          <Row>
            {summaryItems.map((item, index) => (
              <Col xs={12} sm={6} md={3} key={index}>
                <SummaryCard {...item} />
              </Col>
            ))}
          </Row>
          {this.renderFilterBar()}
          <Row>
            <Col xs={12} sm={12} md={12}>
              <ProjectList
                projects={projects || []}
                limit={this.state.pageSize}
                offset={this.state.page * this.state.pageSize}
                limitOptions={[10, 20, 50, 100]}
                total={this.props.filteredCount || (projects ? projects.length : 0)}
                onPageChange={({ limit, offset }) => {
                  const pageSize = limit;
                  const page = Math.max(0, Math.floor((offset || 0) / pageSize));
                  this.setState({ page, pageSize }, () => {
                    this.props.listProject(this.state.page, this.state.pageSize, this.buildFilterParams());
                  });
                }}
              />
            </Col>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.project.orderedIds.map(id => state.project.objects[id]),
  totalCount: state.project.totalCount,
  submittedCount: state.project.submittedCount,
  filteredCount: state.project.filteredCount || state.project.totalCount,
  errorMessage: state.project.errorMessage,
  buildingTypes: state.buildingType.orderedIds.map(id => state.buildingType.buildingTypes[id]),
  provinces: state.province.orderedIds.map(id => state.province.provinces[id]),
  evaluationPurposes: state.reference.evaluationPurpose.evaluationPurposes,
});

const mapDispatchToProps = dispatch => ({
  listProject: (page, pageSize, filterParams) => dispatch(listAllProject(page, pageSize, null, filterParams)),
  getProject: id => dispatch(getProject(id)),
  listBuildingTypes: () => defaultRejectHandler(dispatch(listBuildingType())),
  listProvinces: () => defaultRejectHandler(dispatch(listProvinces())),
  listEvaluationPurpose: () => defaultRejectHandler(dispatch(listEvaluationPurpose())),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(DashboardPage)
);



// WEBPACK FOOTER //
// ./src/pages/dashboard/DashboardPage.js